import { ChangeDetectionStrategy, Component, inject, input, resource, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TimeExportData, TimeExportForm } from '@lib/time-export-form';
import { TimeReportingTable } from '@lib/time-reporting-table';

import { Agreement, Product } from '../schemas';
import { Jira } from '../service';

type TimeOwner = Product | Agreement;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,

  selector: 'lcm-time-reporting-widget',
  imports: [TimeReportingTable, MatToolbarModule, MatTooltipModule, MatButtonModule, MatIconModule, MatTableModule],
  template: `
    <mat-toolbar>
      <h2>Time Reporting</h2>
      <span class="spacer"></span>
      <button matMiniFab matTooltip="Export time reports" [disabled]="pending()" (click)="export()">
        <mat-icon>download</mat-icon>
      </button>
      <button
        matIconButton
        matTooltip="Pull the latest time reports from Jira"
        [disabled]="pending()"
        [class.rotating]="pending()"
        (click)="reload()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </mat-toolbar>
    <lcm-time-reporting-table [table]="timeTable()" />
  `,
})
export class TimeReportingWidget {
  private dialog = inject(MatDialog);
  private jira = inject(Jira);

  project = input.required<TimeOwner>();
  force = signal(false);

  timeTableResource = resource({
    params: () => ({ force: this.force() }),
    defaultValue: { lastUpdated: '', time: [] },
    loader: ({ params }) => this.jira.getProjectTimelogs(this.project(), params.force),
  });

  pending = this.timeTableResource.isLoading;

  timeTable = this.timeTableResource.value;

  async reload() {
    this.force.set(true);
    this.timeTableResource.reload();
  }

  export() {
    const data: TimeExportData = { id: this.project().JiraTitle };
    this.dialog.open(TimeExportForm, { data });
  }
}
